import { Injectable, Provider, inject } from "@angular/core";
import {
    SimulationHistoricalDraftPort
} from "~/app/domains/simulation/v2/domain/ports/simulation-historical/draft-store.port";
import {SimulationHistoricalFacade} from "~/app/core/state/simulation-historical/simulation-historical.facade";
import {
    SIMULATION_HISTORICAL_DRAFT_PORT
} from "~/app/domains/simulation/v2/application/di/simulation-historical.di";

@Injectable({ providedIn: 'root' })
export class SimulationHistoricalNGXSStoreAdapter implements SimulationHistoricalDraftPort<any> {
    private simulationHistoricalFacade = inject(SimulationHistoricalFacade);


    getHistoricalDraftPeriodParams() {
        return this.simulationHistoricalFacade.getDraftPeriodParamsSnapshot();
    }

    getHistoricalDraftComparedEntities() {
        return this.simulationHistoricalFacade.getDraftComparedEntitiesWithoutDataSnapshot();
    }

    getHistoricalDraftBenchmark() {
        return this.simulationHistoricalFacade.getDraftBenchmarkSnapshot();
    }

    setHistoricalDraft(_comparedEntities: any[]): void {
        /* noop - draft update handled elsewhere */
    }

    getViewModeDisplayParams() {
        return this.simulationHistoricalFacade.getViewModeDisplaySnapshot();
    }

    getViewModeParamParams() {
        return this.simulationHistoricalFacade.getViewModeParamSnapshot();
    }

}
/**
 * Provider à enregistrer dans la config/module racine (ou feature).
 * Le Use Case injectera le token, et Angular donnera cet adapter.
 */
export const SIMULATION_HISTORICAL_DRAFT_PORT_PROVIDER: Provider = {
    provide: SIMULATION_HISTORICAL_DRAFT_PORT,
    useExisting: SimulationHistoricalNGXSStoreAdapter,
};
